import * as Matter from 'matter-js';
import type { SceneDef } from './types';
import { createGround, groundTopY } from './util';

export const incline: SceneDef = {
  labelKey: 'scene.incline',
  defaultPlaying: true,
  params: [
    { id: 'angle', labelKey: 'dim.angle', min: 5, max: 60, step: 1, value: 25 },
    { id: 'friction', labelKey: 'dim.friction', min: 0, max: 1, step: 0.05, value: 0.2 },
    { id: 'mass', labelKey: 'dim.mass', min: 0.5, max: 10, step: 0.5, value: 2 },
  ],
  build({ world, dims, bounds }) {
    const angleDeg = dims.angle!;
    const angleRad = (angleDeg * Math.PI) / 180;
    const rampLength = bounds.width * 0.55;
    const rampThickness = 20;
    const rampX = bounds.width * 0.5;
    // Anchor the ramp so its lowest visible end sits a little above the ground.
    const rampY = groundTopY(bounds) - 60;

    // Matter angle is counter-clockwise in a Y-down coord system, so `-angleRad`
    // visually tilts the ramp with the RIGHT end UP.
    const ramp = Matter.Bodies.rectangle(rampX, rampY, rampLength, rampThickness, {
      isStatic: true,
      angle: -angleRad,
      friction: dims.friction!,
    });

    // Place the cube near the high (right) end of the ramp, sitting ON TOP of the surface.
    const boxSize = 40;
    const offsetAlong = rampLength * 0.42; // distance from ramp center along the long axis
    const offsetPerp = (rampThickness + boxSize) / 2; // distance from ramp surface to box center
    // Ramp direction (right end is UP): (cos a, -sin a) in canvas coords.
    // Perpendicular pointing away from the ramp surface (visually UP): (-sin a, -cos a).
    const boxX = rampX + Math.cos(angleRad) * offsetAlong + -Math.sin(angleRad) * offsetPerp;
    const boxY = rampY + -Math.sin(angleRad) * offsetAlong + -Math.cos(angleRad) * offsetPerp;
    const box = Matter.Bodies.rectangle(boxX, boxY, boxSize, boxSize, {
      friction: dims.friction!,
      mass: dims.mass!,
    });

    const ground = createGround(bounds, dims.friction);

    const bodies = [ramp, box, ground];
    Matter.World.add(world, bodies);

    return {
      bodies,
      constraints: [],
      dispose() {
        Matter.World.remove(world, bodies);
      },
    };
  },
};
